/**
 * @generated SignedSource<<924cb9650407dfa35a5142ea997c6075>>
 * @relayHash bb328ffff29b42dfb831c29b3a2a9d51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82cf1d6a552fc846c11b9a5169e9d4b536f73d73f144911cead2ef1f2f87d74a

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomerServiceContextType = "DEFAULT" | "ISSUE" | "%future added value";
export type CustomerServiceFilterInput = {
  context: CustomerServiceContext;
};
export type CustomerServiceContext = {
  issueId?: string | null | undefined;
  type: CustomerServiceContextType;
};
export type panelViewOrganizationQuery$variables = {
  cloudId: string;
  filter: CustomerServiceFilterInput;
  organizationId: string;
};
export type panelViewOrganizationQuery$data = {
  readonly customerService: {
    readonly organizationByOrganizationId: {
      readonly __typename: "CustomerServiceOrganization";
      readonly details: {
        readonly " $fragmentSpreads": FragmentRefs<"detailsView_servicedeskCustomerServiceIssueViewPanel">;
      };
      readonly id: string;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"throwOnQueryError_servicedeskCustomerServiceCommon">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type panelViewOrganizationQuery = {
  response: panelViewOrganizationQuery$data;
  variables: panelViewOrganizationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "identifier"
},
v10 = {
  "kind": "ScalarField",
  "name": "message"
},
v11 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "errorType"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "panelViewOrganizationQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "kind": "LinkedField",
                "name": "organizationByOrganizationId",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "details",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "detailsView_servicedeskCustomerServiceIssueViewPanel"
                          }
                        ]
                      }
                    ],
                    "type": "CustomerServiceOrganization"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW",
              "path": "customerService.organizationByOrganizationId"
            }
          ]
        },
        "action": "THROW",
        "path": "customerService"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "panelViewOrganizationQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "organizationByOrganizationId",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "details",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "CustomerServiceCustomDetailValue",
                            "kind": "LinkedField",
                            "name": "results",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "value"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "values"
                              },
                              {
                                "concreteType": "CustomerServiceCustomDetailType",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "options"
                                  }
                                ]
                              },
                              {
                                "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                    "kind": "LinkedField",
                                    "name": "styleConfiguration",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "optionValue"
                                          },
                                          {
                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "backgroundColour"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "CustomerServiceCustomDetailValues"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "type": "QueryError"
                      }
                    ]
                  }
                ],
                "type": "CustomerServiceOrganization"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "82cf1d6a552fc846c11b9a5169e9d4b536f73d73f144911cead2ef1f2f87d74a",
    "metadata": {},
    "name": "panelViewOrganizationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "755940ad732b81da2c8112e30df1ffd0";

export default node;
